import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { InMemoryCache, from } from '@apollo/client'
import { APOLLO_OPTIONS, ApolloModule } from 'apollo-angular'
import { HttpLink } from 'apollo-angular/http'
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs'
import { AtomModule } from '../atom/atom.module'
import { environment } from '../environments/environment'
import { OrganismModule } from '../organism/organism.module'

@NgModule({
  imports: [
    AtomModule,
    CommonModule,
    ApolloModule,
    HttpClientModule,
    OrganismModule,
  ],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory() {
        return {
          cache: new InMemoryCache({
            // https://github.com/apollographql/apollo-client/issues/7648
            possibleTypes: {
              AcfFieldDefinitionUnion: [
                'StringFieldDefinition',
                'RichTextFieldDefinition',
                'IntegerFieldDefinition',
                'FloatFieldDefinition',
                'BooleanFieldDefinition',
                'DateFieldDefinition',
                'RelationFieldDefinition',
                'GroupFieldDefinition',
              ],
              AcfValueUnion: [
                'StringValue',
                'RichTextValue',
                'IntegerValue',
                'FloatValue',
                'BooleanValue',
                'DateValue',
                'RelationValue',
                'GroupValue',
              ],
            },
          }),
          link: from([
            createUploadLink({
              uri: `${environment.PROTOCOL}${environment.SHOP_API}`,
              credentials: 'include',
            }),
          ]),
        }
      },
      deps: [HttpLink],
    },
  ],
  exports: [HttpClientModule, AtomModule],
  declarations: [],
})
export class AppModule {}
